module.exports = __webpack_public_path__ + "img/cuff_button_diameter.7a325491.png";